export interface PageSeoMeta {
  title?: string;
  description?: string;
  /** When true, ask search engines not to index (admin/login/etc.). */
  noIndex?: boolean;
}

const DEFAULT_TITLE = 'Attractive Unisex Salon & Academy | Hair, Beauty & Bridal – Gondia';
const DEFAULT_DESCRIPTION =
  'Attractive Unisex Salon & Academy in Gondia, Maharashtra. Professional haircuts, colour, skincare, bridal makeup, and beauty training near Ayush Hospital, Rail Toly. Book online.';

const SITE_NAME = 'Attractive Unisex Salon';

function upsertMetaByName(name: string, content: string): void {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertMetaByProperty(property: string, content: string): void {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string): void {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function getPublicSiteUrl(): string {
  const configured = process.env.VUE_APP_PUBLIC_SITE_URL?.replace(/\/$/, '');
  if (configured) return configured;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://attractivesalon.com';
}

/**
 * Updates document title + primary meta tags for the current route.
 * Call from the router after each navigation.
 */
export function applyPageSeo(meta: PageSeoMeta = {}, path = '/'): void {
  const title = meta.title
    ? meta.title.includes(SITE_NAME)
      ? meta.title
      : `${meta.title} | ${SITE_NAME}`
    : DEFAULT_TITLE;
  const description = meta.description || DEFAULT_DESCRIPTION;
  const siteUrl = getPublicSiteUrl();
  const canonical = `${siteUrl}${path === '/' ? '' : path}`;

  document.title = title;
  upsertMetaByName('description', description);
  upsertMetaByName('robots', meta.noIndex ? 'noindex, nofollow' : 'index, follow');
  upsertMetaByProperty('og:title', title);
  upsertMetaByProperty('og:description', description);
  upsertMetaByProperty('og:url', canonical);
  upsertMetaByProperty('og:type', 'website');
  upsertMetaByProperty('og:site_name', SITE_NAME);
  upsertMetaByName('twitter:card', 'summary');
  upsertMetaByName('twitter:title', title);
  upsertMetaByName('twitter:description', description);
  upsertCanonical(canonical);
}

export { DEFAULT_TITLE, DEFAULT_DESCRIPTION, SITE_NAME };
